module.exports = __webpack_public_path__ + "img/Fully immersive integrations.958468ee.gif";